import { render, staticRenderFns } from "./NavbarNumber.vue?vue&type=template&id=4e5beeb6&scoped=true&"
import script from "./NavbarNumber.vue?vue&type=script&lang=js&"
export * from "./NavbarNumber.vue?vue&type=script&lang=js&"
import style0 from "./NavbarNumber.vue?vue&type=style&index=0&id=4e5beeb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5beeb6",
  null
  
)

component.options.__file = "NavbarNumber.vue"
export default component.exports